import { UserInfo } from "../contexts/AuthContext";

export enum RightType {
  ADMIN = "admin",
  RESERVATIONS_ONLY = "reservations_only",
  VIEW_ONLY = "view_only",
  RESERVATIONS_AND_SETTINGS = "reservations_and_settings",
}

export function interactionAllowed(userInfo: UserInfo | null): boolean {
    if (userInfo == null) return false;
    return [RightType.ADMIN, RightType.RESERVATIONS_ONLY, RightType.RESERVATIONS_AND_SETTINGS].includes(userInfo.right_type);
}